//Core Theme files

import 'bootstrap';
import 'typeahead.js';
import 'hammerjs';

//NPM PACKAGES
import tippy from 'tippy.js';
import Tooltip from '@ryangjchandler/alpine-tooltip';
import 'tippy.js/dist/tippy.css';
import $ from 'jquery';
import PerfectScrollbarLib from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import Popper from '@popperjs/core/dist/umd/popper.min';
import languageIT from 'datatables.net-plugins/i18n/it-IT.mjs';
import languageEN from 'datatables.net-plugins/i18n/en-GB.mjs';
import 'pdfjs-viewer-element';

import DataTable from 'datatables.net-bs5';

//Variables
window.$languageIT = languageIT;
window.$languageEN = languageEN;

//Initialize on window propertie
window.$ = $;
window.jQuery = $;
window.PerfectScrollbar = PerfectScrollbarLib;
window.Popper = Popper;
window.Alpine = Alpine;
window.tippy = tippy;
Alpine.plugin(Tooltip);

//Custom Components
import '../assets/js/custom.js';
import '../assets/js/components/alert-notification.js';
import '../assets/js/components/alert-append.js';
// Import custom portal code
import '../assets/js/moretto-portal.js';

//LIVEWIRE PROGRSSBAR AND ERRORS
if (typeof Livewire !== 'undefined') {
  Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
    let timeoutId = setTimeout(() => {
      if ($('.mainLoaderLivewire').hasClass('invisible')) {
        $('.mainLoaderLivewire').removeClass('invisible');
      }
    }, 150);
    respond(() => {
      clearTimeout(timeoutId);
      if (!$('.mainLoaderLivewire').hasClass('invisible')) {
        $('.mainLoaderLivewire').addClass('invisible');
      }
    });
    succeed(({ status, snapshot, effect }) => {
      if (status === 419) {
        window.location.reload();
      }
    });
    fail(() => {});
  });
}

//DATATABLES CUSTOM ERRORS
$.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
  if (settings?.jqXHR) {
    if ([401, 403, 419].includes(settings.jqXHR.status)) {
      window.location = window.location.origin;
      return;
    } else if ([503].includes(settings.jqXHR.status)) {
      alertNotify('warning', 'Service Unavailable', 'Retrying soon...');
    }
  }
  alertNotify('error', null, 'Unexpected Error encountered while rendering the table, please try again later.');
};
//
